import api from './axios';

// Resultado normalizado para DNI/RUC desde el backend.
export interface SunatLookupResult {
  success: boolean;
  documentType?: 'DNI' | 'RUC';
  documentNumber?: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  motherLastName?: string;
  address?: string;
  status?: string;
  taxCondition?: string;
  message?: string;
  source?: string;
}

export interface TipoDocumento {
  codigo: string;
  nombre: string;
  abreviatura: string;
  maxLength: number;
  permiteConsulta: boolean;
}

export const sunatApi = {
  consultarDni: (dni: string) => api.get<SunatLookupResult>(`/sunat/dni/${dni}`),
  consultarRuc: (ruc: string) => api.get<SunatLookupResult>(`/sunat/ruc/${ruc}`),
  getTiposDocumento: () => api.get<TipoDocumento[]>('/sunat/tipos-documento'),
};
